const styles = () => ({
    container: {
        height: 'auto',
        padding: '1em 2em 2em 2em',
    },
});

export default styles;
